import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
const appElement = document.getElementById('maincontent');
Modal.setAppElement(appElement ? appElement : document.getElementsByTagName('body')[0]);
const ModalDrawer = (props) => {
    const { t } = useTranslation();
    const closeButton = () => {
        return (React.createElement("button", { type: "button", "aria-label": t('button.close'), className: classNames('modal__close', props.closeInvertedSm && 'modal__close--inverted-sm'), onClick: (e) => {
                e.stopPropagation();
                (props === null || props === void 0 ? void 0 : props.onRequestClose) && props.onRequestClose(e);
            } }));
    };
    return (React.createElement(Modal, Object.assign({ "aria-labelledby": props.contentLabel ? 'dialog1_label' : '', closeTimeoutMS: 1000 }, props, { overlayClassName: classNames('overlay-modal', 'overlay-modal--drawer', props.overlayClassName), className: classNames('modal', 'modal--drawer', props.className) }),
        props.a11yBar,
        React.createElement("div", { className: "modal__closearea", onClick: (e) => {
                e.stopPropagation();
                (props === null || props === void 0 ? void 0 : props.onRequestClose) && props.onRequestClose(e);
            }, "aria-hidden": "true" }),
        React.createElement("div", { className: "modal__wrapper" },
            React.createElement("div", { className: "modal__container" },
                React.createElement("div", { className: classNames('modal__content', 'container') },
                    !props.buttonInHeader && closeButton(),
                    !props.hideHeader && (React.createElement("div", { className: "modal__header" },
                        props.buttonInHeader && closeButton(),
                        props.contentLabel && !props.hideContentLabel && (React.createElement("h2", { id: "dialog1_label", className: classNames('dialog__title', props.visuallyhidden && 'visually-hidden') }, props.contentLabel)),
                        props.subtitle && React.createElement("p", { className: "dialog__description" }, props.subtitle))),
                    props.hasDivisor && React.createElement("hr", { className: "modal__divisor" }),
                    React.createElement("div", { className: "modal__body" }, props.children))))));
};
export default ModalDrawer;
